import { APIPost, APIGet } from './http';
import { IFetchData } from '../_types/post';
import { MisUseQuery, IMisUseRecord, IMisUseNote, IMemberSummary, IMisUseUpdateRequest } from '../_types/member'
import { IPagedResults } from '../_types/search';
import { IPolicyObject, PolicyObjectTypeOptions } from '../_types/ewpolicy';



export const DefaultMisUseResult: IPagedResults<IMisUseRecord> = {
    Remaining: null,
    Results: null,
    KeyField: [ "id "],
    Page: null,
    PageSize: 50,
    Total: 0,
    query_uuid: ""
};

export const UpdateMisUse = async(request: IMisUseUpdateRequest): Promise<boolean> => {

    let toReturn: boolean = false;;

    let post: IFetchData = {
        authorize: true,
        method: "POST",
        refresh: false,
        service: "ewapi",
        relay_to: "/customer/updatemisuse",
        ...request
    };

    let result = await APIPost<boolean>(post);

    if (result) { toReturn = result; }

    return toReturn;
}

export const ListMisuse = async (query: MisUseQuery): Promise<IPagedResults<IMisUseRecord>> => {

    let toReturn: IPagedResults<IMisUseRecord> = DefaultMisUseResult;

    let post: IFetchData = {
        authorize: true,
        method: "POST",
        refresh: false,
        service: "ewapi",
        relay_to: "/customer/listmisuse",
        ...query
    };

    let result = await APIPost<IPagedResults<IMisUseRecord>>(post);

    if (result) { toReturn = result; }

    return toReturn;

}

export const GetMemberSummaryMisUse = async (id: number): Promise<IMemberSummary | null> => {

    let toReturn: IMemberSummary | null = null;

    let query = {
        user_id: id,
        include_braze: false,
        include_credentials: {include_expired: false, providers: null},
        include_pp: null,
        include_equipment: false,
        include_misuse: { start: null }
    }

    let post: IFetchData = {
        authorize: true,
        method: "POST",
        refresh: false,
        service: "ewapi",
        relay_to: '/customer/getmembersummary',
        ...query
    };

    let result = await APIPost<IMemberSummary>(post);

    if (result) { 
        toReturn = result; 
        (toReturn as IPolicyObject).displayName = toReturn.name;
        (toReturn as IPolicyObject).policies = [];
        (toReturn as IPolicyObject).id = toReturn.id;
        (toReturn as IPolicyObject).objectType = PolicyObjectTypeOptions.user;
    }

    return toReturn;

}

export const GetMemberSummaryDetailed = async (id: number): Promise<IMemberSummary | null> => {

    let toReturn: IMemberSummary | null = null;

    let query = {
        user_id: id,
        include_braze: true,
        include_equipment: true,
        include_credentials: {include_expired: true, providers: null},
        include_pp: { include_last_invoice: true, include_next_invoice: true},
        include_misuse: { start: null }
    }

    let post: IFetchData = {
        authorize: true,
        method: "POST",
        refresh: false,
        service: "ewapi",
        relay_to: '/customer/getmembersummary',
        ...query
    };

    let result = await APIPost<IMemberSummary>(post);


    if (result) { 
        toReturn = result; 
        (toReturn as IPolicyObject).displayName = toReturn.name;
        (toReturn as IPolicyObject).policies = [];
        (toReturn as IPolicyObject).id = toReturn.id;
        (toReturn as IPolicyObject).objectType = PolicyObjectTypeOptions.user;
        
    }

    return toReturn;

}

export const ListMisuseNotes = async (id: number): Promise<IMisUseNote[]> => {

    let toReturn: IMisUseNote[] = [];

    let post: IFetchData = {
        authorize: true,
        method: "GET",
        refresh: false,
        service: "ewapi",
        relay_to: `/customer/listmisusenotes/${id}`
    };

    let result = await APIGet<IMisUseNote[]>(post);

    if (result) { toReturn = result; }

    return toReturn;

}